import { render, staticRenderFns } from "./GoodsSliderPreview.vue?vue&type=template&id=576d06f8&scoped=true&"
import script from "./GoodsSliderPreview.vue?vue&type=script&lang=js&"
export * from "./GoodsSliderPreview.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSliderPreview.vue?vue&type=style&index=0&id=576d06f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576d06f8",
  null
  
)

export default component.exports